<div class="box">
  <div style="width: 75%;" class="flex flex-row">
    <h2 class="page-header">Contacten</h2>
    <button
      mat-flat-button
      class="action-button"
      style="margin: 20px;"
      (click)="createContact()"
    >
      + Nieuw contact
    </button>
  </div>
</div>
<div class="box">
  <div style="width: 75%;" class="table-container panel">
    <div class="example-table-container">
      <table
        mat-table
        [dataSource]="contacts"
        class="example-table"
        matSort
        matSortActive="id"
        matSortDisableClear="true"
        matSortDirection="asc"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle" [mat-sort-header]="">
                <b>Nr</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('id')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            #{{ row.id }}
          </td>
        </ng-container>

        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right" [mat-sort-header]="">
                <b>Voornaam</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('firstName')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.firstName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right" [mat-sort-header]="">
                <b>Achternaam</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('lastName')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.lastName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right" [mat-sort-header]="">
                <b>Telefoonnummer</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('joinedPhoneNumber__contacts')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.phoneNumberDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="mobile">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right" [mat-sort-header]="">
                <b>GSM-nummer</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('mobileNumber__contacts')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.mobileNumberDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef class="header-text">
            <div class="d-flex">
              <div class="text-middle extra-right" [mat-sort-header]="">
                <b>E-mail</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('emails__email')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="table-text">
            {{ row.emailDisplay }}
          </td>
        </ng-container>

        <ng-container matColumnDef="star" stickyEnd>
          <th mat-header-cell *matHeaderCellDef class="header-text"></th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
            class="table-text"
          >
            <mat-menu #actionMenu="matMenu" class="table-text">
              <button
                mat-menu-item
                [routerLink]="['/contacten', element.id]"
                class="center-text"
              >
                <mat-icon class="center-text">edit</mat-icon>
                Bewerken
              </button>
              <button
                mat-menu-item
                (click)="deleteContact(element)"
                class="center-text"
              >
                <mat-icon class="center-text">delete</mat-icon>
                Verwijderen
              </button>
            </mat-menu>
            <div class="text-middle">
              <mat-icon class="fa-2x" [matMenuTriggerFor]="actionMenu"
                >more_vert
              </mat-icon>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          class="table-row"
          [routerLink]="['/contacten', row.id]"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
    ></mat-paginator>
  </div>
</div>
